<template>
  <div>
    <TopLogo />
    <div class="is-flex is-justify-content-center">
      <img
        :src="formHeaderImage"
        :alt="formHeaderImageAltText"
        :width="formHeaderImageWidth"
        :class="formHeaderImageClass"
      />
    </div>

    <div class="px-3 py-6" style="width: 80%; margin:0 auto">
      <div
        :class="`box form-container ${
          isPageHeader
            ? `form-container-height-one`
            : `form-container-height-two`
        }`"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import TopLogo from "../../NsbKycLogo.vue";

export default {
  name: "PageContainer",
  components: {
    TopLogo,
  },
  props: [
    "formHeaderImage",
    "formHeaderImageAltText",
    "formHeaderImageClass",
    "formHeaderImageWidth",
    "isPageHeader",
  ],
  data() {
    return {};
  },
};
</script>
<style>
.welcome_logo {
  width: 30%;
}
.column-container {
  width: 70%;
  margin: auto;
}

/*.form-container {*/
/*  overflow: auto;*/
/*  padding-inline: 5.8% !important;*/
/*}*/

/*.form-container-height-one {*/
/*  max-height: calc(100vh - 167px) !important;*/
/*}*/

/*.form-container-height-two {*/
/*  max-height: calc(100vh - 100px) !important;*/
/*}*/

.form-container::-webkit-scrollbar {
  width: 8px;
}

.form-container::-webkit-scrollbar-track {
  background: rgb(128, 128, 128);
}

.form-container::-webkit-scrollbar-thumb {
  background-color: rgb(66, 66, 66);
  border-radius: 20px;
}
</style>
